$(document).ready(function() {
  $("body").on("click", "input[name=buyMethod]" ,function(e) {
    
    // e.preventDefault();
    // e.stopPropagation();

    var value = $(this).val();

    // $(`input[name=buyMethod]`).attr("checked",false);
    // $(`input[name=buyMethod][value=${value}]`).prop("checked", true);

    
    $(".rental-table-wrapper").hide();
    $(".productView-buyingMethod-Rental").hide();
    if(value === "buy"){
      // .productView-product .productView-price, 
     $(".productView-product .productView-options, .productView-product .quantity_selector, .productView-product .productView-buttons, .productView-product .productView-subtotal").show(); 
    } else if(value === "rental_massage_price_table"){
      $(`#rental_massage_price_table`).show();
      $(`.productView-buyingMethod-Rental`).show();
    } else{
      // .productView-product .productView-price
      $(".productView-product .productView-options, .productView-product .quantity_selector, .productView-product .productView-buttons, .productView-product .productView-subtotal").hide();
      $(`.productView-buyingMethod-Rental.${value}`).show();      
    }
  });

  $("body").on("click", "input[name=buyMethodRental]",function(e) {

    // e.preventDefault();
    // e.stopPropagation();
    
    $(".rental-table-wrapper").hide();
    $(`#${$(this).val()}`).show();
  });
});